<template>
	<div class="puerpera">
		<h3 class="qjc-fts-16 qjc-c-dark qjc-ftw-500">产妇信息</h3>
		
		<h4 class="qjc-fts-14 qjc-c-dark qjc-ftw-500">产前两年内是患过下列疾病？(多选)</h4>
		<el-radio v-model="hasPredis2" label="0" class="qjc-wid-100">无</el-radio>
		<el-radio v-model="hasPredis2" label="1" class="qjc-wid-100">有，请选择（多选）</el-radio>
		
		<el-checkbox-group
			v-model="formData.predis2"
			:disabled="hasPredis2==0?true:false"
		>
			<el-checkbox v-for="item in list" :key="item.val" :label="item.val" :title="item.name">{{ item.name }}</el-checkbox>
		</el-checkbox-group>
		
		<el-button @click="next" class="next qjc-fts-16 qjc-ftw-500">下一步</el-button>
		
	</div>
</template>

<script>
	export default{
		name: 'puerpera',
		data() {
			return {
				list: [
					{ val: 'DIS01', name: '卵巢功能障碍' },
					{ val: 'DIS02', name: '感冒>=3次' },
					{ val: 'DIS03', name: '头颈疾病' },
					{ val: 'DIS04', name: '营养缺乏' },
					{ val: 'DIS05', name: '高血压疾病' },
					{ val: 'DIS06', name: '慢性肝病' },
					{ val: 'DIS07', name: '消化道疾病<3次' },
					{ val: 'DIS08', name: '流产' },
					{ val: 'DIS09', name: '脑血管疾病' },
					{ val: 'DIS10', name: '女性生殖器官肿瘤' },
					{ val: 'DIS11', name: '关节疾患' },
					{ val: 'DIS12', name: '糖尿病' },
					{ val: 'DIS13', name: '慢性阻塞性肺部疾病(COPD)' },
					{ val: 'DIS14', name: '泌尿系统疾患(除肾脏外)' },
					{ val: 'DIS15', name: '肾脏疾病' },
					{ val: 'DIS16', name: '子宫、卵巢相关癌症' },
					{ val: 'DIS17', name: '妊娠疾病' },
					{ val: 'DIS18', name: '癫痫' },
					{ val: 'DIS19', name: '精神疾病+忧郁症' },
					{ val: 'DIS20', name: '甲状腺疾患' },
					{ val: 'DIS21', name: '眼部疾患' },
					{ val: 'DIS22', name: '感冒<3次' },
					{ val: 'DIS23', name: '贫血' },
					{ val: 'DIS24', name: '肥胖及营养过度' },
					{ val: 'DIS25', name: '皮肤疾病' },
					{ val: 'DIS26', name: '恶性肿瘤' },
					{ val: 'DIS27', name: '心脏病' },
					{ val: 'DIS28', name: '消化道疾病>=3次' },
					{ val: 'DIS29', name: '女性生理期疾患' },
					{ val: 'DIS30', name: '头痛' },
					{ val: 'DIS31', name: '痔疮' },
					{ val: 'DIS32', name: '口腔疾患>=3次' },
					{ val: 'DIS33', name: '痛风' },
					{ val: 'DIS34', name: '良性肿瘤' },
					{ val: 'DIS35', name: '乳癌' },
					{ val: 'DIS36', name: '腹部骨盆疾病' },
					{ val: 'DIS37', name: '乳房疾患' },
					{ val: 'DIS38', name: '霉菌病' },
					{ val: 'DIS39', name: '口腔疾患<3次' },
					{ val: 'DIS41', name: '肺炎' }
				],
			
				hasPredis2: this.formData.predis2.length>0?'1':'0'// 是否患病
				
			}
		},
		props: ['formData'],
		watch: {
			hasPredis2(val) {// 选择无疾病时清空已选项
				if(val == '0'){
					this.formData.predis2 = [];
				}
			}
		},
		methods: {
			next() {
				if(this.hasPredis2 == '0' && this.formData.predis2.length > 0){
					this.$myAlert({
						type: 'fail',
						title: '选择错误'
					});
				}else if(this.hasPredis2 == '1' && this.formData.predis2.length == 0){
					this.$myAlert({
						type: 'fail',
						title: '选择错误',
						content: '请选择至少一种疾病或无患病'
					});
				}else{
					this.$emit('checkTab', 'Biochemical');
				}
			}
		}
	}
</script>

<style scoped>
	.el-radio >>> .el-radio__label,
	.el-checkbox >>> .el-checkbox__label{
		font-size: 0.14rem;
		line-height: 0.14rem;
		color: #777F8F;
	}
	.el-checkbox >>> .el-checkbox__label{
		padding-left: 0.06rem;
	}
</style>
<style lang="scss" scoped>
	.puerpera{
		padding-top: 0.32rem;
		
		&>h4{
			margin: 0.24rem 0 0.16rem;
		}
		
		.el-radio{
			margin-bottom: 0.16rem;
		}
		
		.el-checkbox-group{
			background-color: #F2F4FD;
			border: 0.01rem solid #E5E9F9;
			border-radius: 0.04rem;
			
			.el-checkbox{
				width: 16.666%;
				line-height: 0.14rem;
				margin-right: 0;
				padding: 0.11rem 0.16rem;
				border-bottom: 0.01rem solid #fff;
				overflow: hidden;
				
				&:not(:nth-child(6n)){
					border-right: 0.01rem solid #fff;
				}
			}
		}
		
		.next{
			display: block;
			width: 2rem;
			line-height: 0.48rem;
			margin: 0.6rem auto 0;
		}
	}
</style>
